import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { ISites } from '../../Interfaces/ISites';
import { SitesService } from '../../services/sites-services';
import { DisableSiteComponent } from '../../sites/disable-site/disable-site.component';
import { IRoles } from '../../Interfaces/IRoles';
import { RolesService } from '../../services/roles-service';

@Component({
	selector: 'app-diable-role',
	templateUrl: './disable-role.component.html',
	styles: [],
})
export class DisableRoleComponent implements OnInit {
	loading: boolean = false;
	constructor(
		private dialogRef: MatDialogRef<DisableSiteComponent>,
		@Inject(MAT_DIALOG_DATA) public data: IRoles,
		private notificationService: NotificationService,
		private translateService: TranslateService,
		public translate: TranslateApplicationService,
		private roleService: RolesService,
	) {}

	ngOnInit(): void {}

	Approve() {
		this.roleService.ChangeRoleStatus(this.data).subscribe(
			(result: TransactionResult<Boolean>) => {
				this.loading = false;
				if (result.success) {
					this.Alert(
						'Success',
						this.translate.TranslateKey('COMPLETE'),	
          			);
          			this.Close();
				} else {
					this.Alert(
						'Warning',
						this.translate.TranslateKey('WARNING.Failed_updated_status'),
					);
				}
			},
			(error: any) => { this.ErrorAlert(error); this.loading = false; },
		);
	}

	Close() {
		this.dialogRef.close(true);
	}

	Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: message,
			shown: true,
		});
	}

	ErrorAlert(message: any) {
		this.notificationService.AddAlert({
		  icon: 'all_inbox',
		  title: 'Error',
		  message: message,
		  shown: true,
		});
	  }
}
